export function showCartPill(start, now = Date.now()) {
  const at = Date.parse(start);
  return Number.isFinite(at) && now >= at;
}
if (typeof customElements !== 'undefined' && !customElements.get('sc-cart-launch-pill')) {
  customElements.define('sc-cart-launch-pill', class extends HTMLElement {
    connectedCallback() {
      this.update = () => { this.hidden = !showCartPill(this.dataset.start); };
      this.update();
      this.timer = setInterval(this.update, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
